<template>
    <v-card width="400" outlined>
        <v-card-title><v-icon>mdi-trash-can-outline</v-icon> Delete Event?</v-card-title>
        <v-card-subtitle>Event Name: {{happName}}</v-card-subtitle>
        <v-card-subtitle>Number of participants: {{numOfParticipants}}</v-card-subtitle>
        <v-card-text>
                 <v-row>
                    <!-- <v-col>
                    </v-col> -->
                    <v-col>
                        <v-btn :disabled="!isValid" color="primary" @click="submit" rounded>YES DELETE: {{happName}}</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn color="lightgrey" link :to="cancellink.to" rounded>Cancel</v-btn>
                    </v-col>
                </v-row>
                <div>.</div>
                <v-row>
                <v-alert type="success" :value="isAlertVisible">
                    {{statusResultMsg}}
                </v-alert>
                <v-alert type="warning" :value="isWarningAlertVisible">
                    {{statusResultMsg}}
                </v-alert>
                </v-row>
        </v-card-text>
    </v-card>
</template>

<script>
import axios from 'axios'

export default {
    name: "DeleteHapp",
    props: {
    happ:[],
    regId: Number,
    ac: String
  },
    data: () => ({
    // happName: null,
    happName: null,
    isValid: true,
    isAlertVisible: false,
    isWarningAlertVisible: false,
    select: null,
    errors: [],
    statuses: [],
    statusResult: Number,
    statusResultMsg: String,
    cancellink: {to: '/'}, 
    //   text: String,
    //   showComponent: Boolean,
    //   compValue: String,
    //   valueInComponent: String

    
    }),

  created () {
    //this.baseUrl = 'http://localhost:3000/dbapi/' //https://pgbox.azurewebsites.net:3000/
    this.baseUrl = 'https://pgapi.azurewebsites.net/dbapi/'
    this.happName = this.happ.HappName;
    this.numOfParticipants = this.happ.AntPilots;
    this.statusResult = null
    this.statusResultMsg = null
    this.valueInComponent = "no"
  },
  methods: {
    submit () {
        var regId = this.regId;
        var ac = this.ac;
        var happId = this.happ.HappId;
      var toSubmit = JSON.stringify({ regId, ac, happId})
      const uri = this.baseUrl + 'deletehapp';
      console.log("uri:",uri);
    //   console.log("toSubmit:",toSubmit);
      this.postdelete(uri, toSubmit);
    },

    postdelete (uri, toSubmit) {
      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
          'Access-Control-Allow-Origin': '*'
        }
      }
      axios.post(uri, toSubmit, axiosConfig).then((response) => {
          console.log("response",response.data);
        this.statusResult = response.data[0].Result
        this.statusResultMsg = response.data[0].ResultMsg
        this.setAlert(this.statusResult)
        // if(this.statusResultMsg == 1) {
        // something
        // }

      })
        .catch(e => {
          this.errors.push(e)
        })
    },
    setValueMethodInView(value) {
        this.valueInComponent = value;
    },

    setAlert(statusResult) {
      if (statusResult === 1) {
        this.isAlertVisible = true;
        this.isWarningAlertVisible = false;
      }
      if (statusResult === 0) {
        this.isWarningAlertVisible = true;
        this.isAlertVisible = false;
      }
    }
  },
}
</script>